import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faGraduationCap,
	faCalendarAlt,
} from "@fortawesome/free-solid-svg-icons";
import { VIEW_MODES } from "../constants";
import styles from "../GradesPage.module.css";

const GradesHeader = ({
	classData,
	viewMode,
	selectedSemester,
	onViewModeChange,
	onSemesterChange,
}) => {
	return (
		<div className={styles.header}>
			<div className={styles.title}>
				<h1>
					<FontAwesomeIcon
						icon={faGraduationCap}
						className={styles.titleIcon}
					/>
					Grades Management
				</h1>
				<p className={styles.subtitle}>
					{classData?.gradeLevel} - Manage student grades and assessments
				</p>
			</div>
			<div className={styles.headerActions}>
				<div className={styles.viewModeSwitch}>
					<span className={styles.viewModeLabel}>View by</span>
					<div className={styles.viewModeTabs}>
						<button
							className={`${styles.viewModeTab} ${
								viewMode === VIEW_MODES.SUBJECTS ? styles.active : ""
							}`}
							onClick={() => onViewModeChange(VIEW_MODES.SUBJECTS)}
						>
							Subjects
						</button>
						<button
							className={`${styles.viewModeTab} ${
								viewMode === VIEW_MODES.STUDENTS ? styles.active : ""
							}`}
							onClick={() => onViewModeChange(VIEW_MODES.STUDENTS)}
						>
							Students
						</button>
					</div>
				</div>

				<div className={styles.semesterSwitch}>
					<span className={styles.semesterLabel}>
						<FontAwesomeIcon icon={faCalendarAlt} /> Semester
					</span>
					<div className={styles.semesterTabs}>
						<button
							className={`${styles.semesterTab} ${
								selectedSemester === 1 ? styles.active : ""
							}`}
							onClick={() => onSemesterChange(1)}
						>
							1st
						</button>
						<button
							className={`${styles.semesterTab} ${
								selectedSemester === 2 ? styles.active : ""
							}`}
							onClick={() => onSemesterChange(2)}
						>
							2nd
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default GradesHeader;
